import React, { useState } from 'react';
import {
  Modal, Box, Typography, TextField, Button, Grid, RadioGroup,
  FormControlLabel, Radio, Checkbox, Divider, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';

export default function AddBankAccountModal({ open, onClose, onSubmitSuccess }) {
  const [form, setForm] = useState({
    name: '',
    notes: '',
    type: 'Checking',
    country: 'United States',
    routing: '',
    account: '',
    epay: false,
    creditCard: false,
    vendorPayments: false,
    remotePrint: false,
    localPrint: false,
    checkStock: 'Blank',
    checkFormat: '',
    signatureHeading: '',
    fractionalNumber: '',
    bankInfo: '',
    overrideCompany: false,
    companyName: 'Memphis Passive LLC',
    street: '8016 US Highway 70',
    cityState: 'Bartlett, TN 38133',
    perDeposit: 0,
    monthlyDeposit: 0,
    perWithdrawal: 0,
    monthlyWithdrawal: 0,
    status: 'Active',
    last4: '',
    lastReconciliationDate: '',
    undepositedFunds: 0,
    balance: 0
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

const handleSubmit = async () => {
  const account = form.account || '';
  const last4 = account.slice(-4);

  await addDoc(collection(db, 'bankAccounts'), {
    ...form,
    last4,
    createdAt: serverTimestamp()
  });

  onSubmitSuccess();
  onClose();
};

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ p: 4, width: '80%', maxWidth: 900, maxHeight: '90vh', overflowY: 'auto', bgcolor: 'background.paper', mx: 'auto', mt: 4, borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>Add Bank Account</Typography>
        <Divider sx={{ mb: 3 }} />

        {/* Bank Info */}
        <Box mb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField fullWidth label="Bank Account Name" name="name" value={form.name} onChange={handleChange} required /></Grid>
            <Grid item xs={12}><TextField fullWidth multiline label="Account Notes" name="notes" value={form.notes} onChange={handleChange} /></Grid>
            <Grid item xs={6}><FormControl fullWidth><InputLabel>Country</InputLabel><Select name="country" value={form.country} onChange={handleChange}><MenuItem value="United States">United States</MenuItem></Select></FormControl></Grid>
            <Grid item xs={6}><RadioGroup row name="type" value={form.type} onChange={handleChange}><FormControlLabel value="Checking" control={<Radio />} label="Checking" /><FormControlLabel value="Savings" control={<Radio />} label="Savings" /></RadioGroup></Grid>
            <Grid item xs={6}><TextField fullWidth label="Routing Number" name="routing" value={form.routing} onChange={handleChange} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Account Number" name="account" value={form.account} onChange={handleChange} /></Grid>
          </Grid>
        </Box>

        {/* Check Printing */}
        <Box mb={3}>
          <Typography variant="subtitle1">Check Printing Information</Typography>
          <FormControlLabel control={<Checkbox checked={form.remotePrint} name="remotePrint" onChange={handleChange} />} label="Enable remote check printing" />
          <FormControlLabel control={<Checkbox checked={form.localPrint} name="localPrint" onChange={handleChange} />} label="Enable local check printing" />
          <RadioGroup row name="checkStock" value={form.checkStock} onChange={handleChange}>
            <FormControlLabel value="Blank" control={<Radio />} label="Blank" />
            <FormControlLabel value="Printed" control={<Radio />} label="Pre-printed with account and routing" />
          </RadioGroup>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}><TextField fullWidth label="Check Format" name="checkFormat" value={form.checkFormat} onChange={handleChange} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Signature Heading" name="signatureHeading" value={form.signatureHeading} onChange={handleChange} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Fractional Number" name="fractionalNumber" value={form.fractionalNumber} onChange={handleChange} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Bank Information" name="bankInfo" value={form.bankInfo} onChange={handleChange} /></Grid>
          </Grid>
        </Box>

        {/* Company Info */}
        <Box mb={3}>
          <Typography variant="subtitle1">Company Information</Typography>
          <FormControlLabel control={<Checkbox checked={form.overrideCompany} name="overrideCompany" onChange={handleChange} />} label="Override company information" />
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField fullWidth label="Company Name" name="companyName" value={form.companyName} onChange={handleChange} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Street" name="street" value={form.street} onChange={handleChange} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="City, State ZIP" name="cityState" value={form.cityState} onChange={handleChange} /></Grid>
          </Grid>
        </Box>

        {/* ePay Info */}
        <Box mb={3}>
          <Typography variant="subtitle1">ePay Information</Typography>
          <FormControlLabel control={<Checkbox checked={form.epay} name="epay" onChange={handleChange} />} label="Enabled for EFT" />
          <FormControlLabel control={<Checkbox checked={form.creditCard} name="creditCard" onChange={handleChange} />} label="Enabled for Credit Cards" />
          <FormControlLabel control={<Checkbox checked={form.vendorPayments} name="vendorPayments" onChange={handleChange} />} label="Enabled for Vendor Payments" />
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}><TextField fullWidth label="Per Deposit Limit" name="perDeposit" value={form.perDeposit} onChange={handleChange} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Monthly Deposit Limit" name="monthlyDeposit" value={form.monthlyDeposit} onChange={handleChange} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Per Withdrawal Limit" name="perWithdrawal" value={form.perWithdrawal} onChange={handleChange} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Monthly Withdrawal Limit" name="monthlyWithdrawal" value={form.monthlyWithdrawal} onChange={handleChange} /></Grid>
          </Grid>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button variant="outlined" onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>Create Account</Button>
        </Box>
      </Box>
    </Modal>
  );
}